const axios = require('axios');

export default async function getAsesores() {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage._session_token}`
            }
        }
        let { data } = await axios.get(`${process.env.api}/asesores`, config)
        return { data, error: null };
    } catch (error) {
        return { data: null, error: error };
    }
}